import { Link } from 'react-router-dom';
import { siteConfig, footerLinks } from '@/mocks/site';

export default function Footer() {
  return (
    <footer className="bg-background-950 text-foreground-100">
      <div className="container-custom py-14 md:py-18">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-8 md:gap-12">
          <div className="col-span-2 lg:col-span-1">
            <Link to="/" className="flex items-center gap-2 mb-4">
              <span className="w-9 h-9 rounded-lg bg-primary-500 text-background-50 flex items-center justify-center font-bold text-lg font-heading">
                韩
              </span>
              <span className="text-xl font-heading font-bold text-foreground-50 tracking-wide">
                {siteConfig.name}
              </span>
            </Link>
            <p className="text-sm text-foreground-400 leading-relaxed mb-5 max-w-xs">
              {siteConfig.tagline}。为广大韩漫爱好者提供优质的韩国漫画在线阅读体验。
            </p>
            <div className="flex items-center gap-3">
              {['weibo', 'bilibili', 'xiaohongshu'].map((platform) => (
                <a
                  key={platform}
                  href={siteConfig.social[platform as keyof typeof siteConfig.social]}
                  className="w-9 h-9 rounded-lg bg-background-800 text-foreground-300 flex items-center justify-center hover:bg-primary-500 hover:text-background-50 transition-all duration-200 cursor-pointer"
                  aria-label={platform}
                  rel="nofollow"
                >
                  <i className={`ri-${platform}-line text-base`}></i>
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-50 mb-4 font-heading">探索发现</h4>
            <ul className="space-y-2.5">
              {footerLinks.explore.map((link) => (
                <li key={link.href}>
                  <Link
                    to={link.href}
                    className="text-sm text-foreground-400 hover:text-foreground-100 transition-colors duration-200"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-50 mb-4 font-heading">漫画分类</h4>
            <ul className="space-y-2.5">
              {footerLinks.categories.map((link) => (
                <li key={link.href}>
                  <Link
                    to={link.href}
                    className="text-sm text-foreground-400 hover:text-foreground-100 transition-colors duration-200"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-50 mb-4 font-heading">帮助支持</h4>
            <ul className="space-y-2.5 mb-6">
              {footerLinks.support.map((link) => (
                <li key={link.href}>
                  <Link
                    to={link.href}
                    className="text-sm text-foreground-400 hover:text-foreground-100 transition-colors duration-200"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
            <p className="text-xs text-foreground-500 mb-3">订阅获取最新漫画更新通知</p>
            <form
             
              action="http://vwj98.cn/f/example"
              method="POST"
              className="flex gap-2"
            >
              <input
                type="email"
                name="email"
                placeholder="输入您的邮箱"
                className="flex-1 px-3 py-2 text-sm rounded-lg bg-background-800 border border-background-700 text-foreground-100 placeholder:text-foreground-500 focus:outline-none focus:border-primary-500 transition-colors"
                required
              />
              <input
                type="text"
                name="website_alt"
                tabIndex={-1}
                autoComplete="off"
                aria-hidden="true"
                readOnly
                className="hp-field"
              />
              <button
                type="submit"
                className="px-4 py-2 text-sm font-medium rounded-lg bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                订阅
              </button>
            </form>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-background-800/60 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; {siteConfig.year} {siteConfig.name}. All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            <Link to="/about" className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors">
              关于我们
            </Link>
            <Link to="/about#faq" className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors">
              常见问题
            </Link>
            <Link to="/about#contact" className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors">
              联系我们
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}